
export enum Path {
  Home = '/',
  Home2 = '/home',
  About = '/about',
  Contact = '/contact',
  Events = '/events',
  Admission = '/admission',




 

}
